import styled from "styled-components";
export const HomeContainer = styled.div`
  background-image: url("images/12T-Site.jpg");
  background-repeat: no-repeat;
  height: 90vh;
  background-size: cover;
  background-position: center;
`;
